module.exports = __webpack_public_path__ + "img/d2.8b76ddc7.png";